import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';

import GenericFooter from 'components/GenericFooter';
import FooterPlaceholder from './FooterPlaceholder';

const getFooterItems = (CmsStatic) => {
  const { isLoading, error } = CmsStatic;
  if (isLoading) {
    return { isLoading }
  } else if (error) {
    const message = error?.message || 'Erro ao carregar!';
    const status = error?.response?.status || "ERR_NETWORK";
    return { error: {message, status}}
  }
  const { cms: { footerMenu } } = CmsStatic
  return { ...footerMenu }
};

const FooterDefault = () => {
  const oidc = useSelector((state) => state?.oidc);
  const CmsStatic = useSelector((state) => state?.CmsStatic);
  const footerItems = getFooterItems(CmsStatic);
  if ((!CmsStatic || CmsStatic?.isLoading) && oidc?.user?.profile) return <FooterPlaceholder />
  return (<>
    {oidc?.user?.profile && (<>
      <GenericFooter
          {...footerItems}
      />
    </>)}
  </>);
};

export default FooterDefault;
